import React, { useCallback, useEffect, useRef, useState } from 'react';
import config from './config.json';
import { message } from 'antd';
import { modalAddOrEditFn } from './components/addOrEdit';
import { SActionBtn, SLowcodeList, STableActions } from 'shj-components'
import { billPrintConfigPageList, billPrintConfigStateActionPage, esignCommonList } from '@/services/fmsConfig'
import { getPrintTemplateList } from '@/services'
import { httpCompanyList } from '@/services/fmsServices'
export default function () {
  const listRef = useRef<any>();
  const [statusLoading, setStatusLoading] = useState<string[]>([]);  // 存储正在切换状态的行 id
  // 表格加载
  const fetchList = (values: any) => {
    const { current, pageSize, ...rest } = values;
    return new Promise(async (resolve, reject) => {
      try {
        let data = await billPrintConfigPageList(current, pageSize, rest.query);
        const { records, total } = data;
        resolve({ records, total });
      } catch (e) {
        reject({ success: false });
      }
    });
  };

  const getStatusOptions = () => {
    return new Promise(async (resolve, reject) => {
      // let orgCompanyList = await esignCommonList() //财务主体
      let orgCompanyList = await httpCompanyList()
      let printTemplateArr = await getPrintTemplateList({ name: '' })
      resolve({
        printTemplateArr: printTemplateArr,
        companyArr: orgCompanyList,
      });
    });
  };

  // 刷新
  const reloadFn = () => {
    const {
      current: { reload },
    } = listRef;
    reload();
  };

  // 新增
  const add = (obj = {}) => {
    const {
      current: { reload },
    } = listRef;
    modalAddOrEditFn({
      fn: () => {
        reload();
      },
      ...obj,
    });
  };
  const edit = (obj: object) => {
    add(obj);
  };

  const onSave = useCallback((values, dialogDestroy) => { }, []);

  const onAdd = useCallback(() => {
    add();
  }, [onSave]);

  const onEdit = useCallback(
    (record) => {
      edit(record);
    },
    [onSave],
  );

  const handleStateChange = useCallback(async (state: number, records: any[]) => {
    const ids = records.map(record => record.id);
    setStatusLoading(prev => [...prev, ...ids]);
    try {
      const response = await billPrintConfigStateActionPage({ ids, state });
      message.success(response?.message || '操作成功');
      reloadFn();
    } catch (error) {
      // message.error('操作失败');
    } finally {
      setStatusLoading(prev => prev.filter(id => !ids.includes(id)));
    }
  }, [reloadFn]);

  const onDisable = useCallback(({ selectedRows = [] } = {}) => {
    handleStateChange(0, selectedRows);
  }, [handleStateChange]);

  const onEnable = useCallback(({ selectedRows = [] } = {}) => {
    handleStateChange(1, selectedRows);
  }, [handleStateChange]);

  const onEnableChange = useCallback((checked: boolean, record: any) => {
    handleStateChange(checked ? 1 : 0, [record]);
  }, [handleStateChange]);
  
  const extension = {
    request: { fetchList, getStatusOptions },
    events: { onAdd, onEnable, onDisable, onEnableChange },
    status: {
      btnDisabled: ({ selectedRowKeys }: any) => selectedRowKeys.length <= 0,
    },
    customRender: {
      // 渲染操作栏
      renderOperate(text: string, record: any) {
        return (
          <div className="actionBox">
            <STableActions>
              <SActionBtn onClick={() => onEdit(record)}>
                {/* auth="billPrintConfigButton4"*/}
                编辑
              </SActionBtn>
              <SActionBtn 
              loading={statusLoading.includes(record.id)}
              onClick={() => handleStateChange(record.enabled?0:1,[record])}
            >
              {record?.enabled ? '禁用' : '启用'}
            </SActionBtn>
            </STableActions>
          </div>
        );
      },
    },
  };

  return <><SLowcodeList config={config} ref={listRef} {...extension} searchMode="group" /></>
}
